import { useState } from 'react';
import PropTypes from 'prop-types';
// material
import { alpha, styled } from '@mui/material/styles';

import {
  Card,
  Box,
  Typography,
  Modal,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button
} from '@mui/material';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.primary.darker,
  backgroundColor: '#FFFFFF'
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 1
};

AssignDeviceModal.propTypes = {
  opneAssignedModal: PropTypes.bool,
  handleClose: PropTypes.func
};

export default function AssignDeviceModal({ opneAssignedModal, handleClose }) {
  const [logType, setLogType] = useState('');
  const [device, setDevice] = useState('');
  const [fos, setFos] = useState('');

  const handleLogTypeChange = (event) => {
    setLogType(event.target.value);
  };
  const handleDeviceChange = (event) => {
    setLogType(event.target.value);
  };
  const handleFOSChange = (event) => {
    setLogType(event.target.value);
  };

  return (
    <Box>
      <Modal
        open={opneAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography sx={{ fontSize: 18, fontWeight: 900 }}>Assign a Device</Typography>

          <FormControl fullWidth sx={{ mb: 3, mt: 3 }}>
            <InputLabel id="demo-simple-select-label">Device Type</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={logType}
              label="Device Type"
              onChange={handleLogTypeChange}
            >
              <MenuItem value={10}>ProY</MenuItem>
              <MenuItem value={20}>Sleefe</MenuItem>
              <MenuItem value={30}>Lock</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ mb: 3 }}>
            <InputLabel id="demo-simple-select-label">Device</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={device}
              label="Log Type"
              onChange={handleDeviceChange}
            >
              <MenuItem value={10}>SL-01</MenuItem>
              <MenuItem value={20}>SL-05</MenuItem>
              <MenuItem value={30}>SL-11</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ mb: 3 }}>
            <InputLabel id="demo-simple-select-label">FOS</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={fos}
              label="Log Type"
              onChange={handleFOSChange}
            >
              <MenuItem value={10}>Krishna</MenuItem>
              <MenuItem value={20}>Sumit</MenuItem>
              <MenuItem value={30}>Narendra</MenuItem>
            </Select>
          </FormControl>

          <Button variant="contained" fullWidth size="large">
            Assign
          </Button>
        </Box>
      </Modal>
    </Box>
  );
}
